import React, { useEffect, useState } from "react";
import "./Slideshow.css";
import axios from "axios";
import { placeholderImage } from "../../assets";
import { hostURL } from "../../services/data_requests";

const Slideshow = () => {
  const [artworks, setArtworks] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const fetchArtworks = async () => {
      try {
        const res = await axios.get(`${hostURL}artwork`);
        if (Array.isArray(res.data)) {
          setArtworks(res.data.slice(0, 10));
        } else if (res.data?.data && Array.isArray(res.data.data)) {
          setArtworks(res.data.data.slice(0, 10));
        }
      } catch (error) {
        console.error("Error fetching artworks:", error);
      }
    };
    fetchArtworks();
  }, []);

  useEffect(() => {
    if (artworks.length === 0) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % artworks.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [artworks]);

  const currentArtwork = artworks[currentIndex];
  const imageSrc = currentArtwork?.img_url || placeholderImage;

  return (
    <div className="slideshow2">
      <img
        src={imageSrc}
        alt={currentArtwork?.title || "Artwork"}
        className="slide-image2"
      />
    </div>
  );
};

export default Slideshow;